export const COLORS = [
  '#EF3EB5',
  '#4B256D',
  '#40E0D0',
  '#000000',
  '#FF0000',
  '#00FF00',
  '#FFD700',
  '#695D54',
];

export const boxShadowCard =
  '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';

export const parameterTypes = {
  AGUA: 'Água',
  ANIMAL: 'Animal',
  SAUDE: 'Saúde',
};

export const POND_TYPES = {
  PRE_BERCARIO: 'Pré-Berçário',
  BERCARIO: 'Berçário',
  ENGORDA: 'Engorda',
  TANQUE_REDE: 'Tanque-Rede',
};

// Preparando - Quando o viveiro acabou de entrar no ciclo.

// Cultivando - Está ativo no ciclo.

// Despescado - Quando alcançar 100% de despesca do viveiro.

// Transferido - Quando alcançar 100% de transferência do viveiro.

// Interrompido - Quando o viveiro foi  interrompido por algum problema.

export const POND_STATUS_CYCLE = {
  PREPARANDO: 'Preparando',
  CULTIVANDO: 'Cultivando',
  DESPESCADO: 'Despescado',
  TRANSFERIDO: 'Transferido',
  INTERROMPIDO: 'Interrompido',
  CONCLUIDO: 'Concluído',
};

export const POND_STATUS = {
  MANUTENCAO: 'Manutenção',
  DISPONIVEL: 'Disponível',
};

export const pondStatusNursery = [
  {
    key: 1,
    value: POND_STATUS.DISPONIVEL,
    filterDashboardValue: 'available',
  },
  {
    key: 2,
    value: POND_STATUS.MANUTENCAO,
    filterDashboardValue: 'maintenance',
  },
];

export const pondStatusCycle = [
  {
    key: 1,
    value: POND_STATUS_CYCLE.PREPARANDO,
    filterDashboardValue: 'preparing',
  },
  {
    key: 2,
    value: POND_STATUS_CYCLE.CULTIVANDO,
    filterDashboardValue: 'cultivating',
  },
  {
    key: 3,
    value: POND_STATUS_CYCLE.DESPESCADO,
    filterDashboardValue: 'harvested',
  },
  {
    key: 4,
    value: POND_STATUS_CYCLE.TRANSFERIDO,
    filterDashboardValue: 'transferred',
  },
  {
    key: 5,
    value: POND_STATUS_CYCLE.CONCLUIDO,
    filterDashboardValue: 'finished',
  },
];

export const pondTypes = [
  {
    key: 1,
    value: POND_TYPES.PRE_BERCARIO,
    filterDashboardValue: 'pre_nursery',
  },
  {
    key: 2,
    value: POND_TYPES.BERCARIO,
    filterDashboardValue: 'nursery',
  },
  {
    key: 3,
    value: POND_TYPES.ENGORDA,
    filterDashboardValue: 'fatten',
  },
  {
    key: 4,
    value: POND_TYPES.TANQUE_REDE,
    filterDashboardValue: 'net_tank',
  },
];

export const productionSystem = [
  {
    key: 1,
    value: 'Semi-Extensivo',
  },
  {
    key: 2,
    value: 'Extensivo',
  },
  {
    key: 3,
    value: 'Semi-Intensivo',
  },
  {
    key: 4,
    value: 'Intensivo',
  },
  {
    key: 5,
    value: 'Superintensivo',
  },
];

export const workProtocol = [
  {
    key: 1,
    value: 'Bioflocos',
  },
  {
    key: 2,
    value: 'Convencional',
  },
  {
    key: 3,
    value: 'Heterotróficos',
  },
  {
    key: 4,
    value: 'Simbióticos',
  },
  {
    key: 5,
    value: 'Outro',
  },
];

export const MAXIMUN_INPUT_VALUE = 100000000;

export const contactUsPhone = '5583981839411';

export const isCrevettic = process.env.REACT_APP_PLATAFORM === 'crevettic';

export const LINK_TO_PRIVACY_POLICY = `${process.env.PUBLIC_URL}/Politica_de_privacidade_e_seguranca_Greenfy.pdf`;

export const listOfBanks = [
  'Agibank',
  'Banco ABC Brasil',
  'Banco BMG',
  'Banco Bradesco',
  'Banco BTG Pactual',
  'Banco C6',
  'Banco Daycoval',
  'Banco do Brasil',
  'Banco Fibra',
  'Banco Inter',
  'Banco Itaú',
  'Banco Modal',
  'Banco Neon',
  'Banco Original',
  'Banco PAN',
  'Banco Pine',
  'Banco Renner',
  'Banco Safra',
  'Banco Santander',
  'Banco Votorantim',
  'BS2 (Banco Bonsucesso)',
  'Caixa Econômica Federal',
  'Conta Digital do Banco do Brasil',
  'Digio',
  'Méliuz',
  'Modalmais',
  'Next (do Bradesco)',
  'Nubank',
  'PagBank (do PagSeguro)',
  'Superdigital (do Santander)',
  'Trigg',
  'Woop Sicredi',
  'Zro Bank',
];

export const maximumInstallments = 30;

export const polycultureSpecies = ['Camarão', 'Peixe'];

export const MEASUREMENT_TYPES = {
  [parameterTypes.AGUA]: 'Análise de Água',
  [parameterTypes.ANIMAL]: 'Biometria',
  [parameterTypes.SAUDE]: 'Análise de Saúde',
};

export const listPermissions = {
  PERFORMANCE: 'performance', // Desempenho
  REPORTS: 'reports', // Relatórios
  PRODUCTION: 'production', // Produção
  SHOPPING: 'shopping', // Compras
  FINANCIAL: 'financial', // Financeiro
  COMMERCIAL: 'commercial', // Comercial
  EMPLOYEES: 'employees', // Funcionários
};
